import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-calendar-booking-detail-dialog",
  templateUrl: "./calendar-booking-detail-dialog.component.html",
  styleUrls: ["./calendar-booking-detail-dialog.component.css"],
})
export class CalendarBookingDetailDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() bookingDetail: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  posterURL = environment.posterURL;
  userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  codeList: any = [];
  isUniversityJob : boolean = false ;
  tosterConfig = {
    positionClass: "toast-top-center",
  };

  constructor(
    private activeModal: NgbActiveModal,
    private route: Router,
    public _DomSanitizationService: DomSanitizer
  ) { }

  ngOnInit() {
    this.bookingJobType();
    console.log("bookingDetail", this.bookingDetail);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  bookingJobType() {
    if (this.bookingDetail.job_detail.shoot_type == 'Nursery') {
      this.isUniversityJob = false;
    } else if (this.bookingDetail.job_detail.shoot_type == 'School' || this.bookingDetail.job_detail.shoot_type == 'University') {
      this.isUniversityJob = true;
    }
  }
  

  formatTime(time: string): string {
    if (time != null || time != "null") {
      const [hours, minutes] = time.split(/:|\./);
      const formattedHours = +hours % 12 || 12;
      const period = +hours >= 12 ? 'PM' : 'AM';
      return `${formattedHours}:${minutes} ${period}`;
    }
  }

  onEditBooking() {
    this.route.navigate(["/AdminPanel/booking-form"], {
      queryParams: {
        site_id: this.bookingDetail.job_detail.site_id,
        job_id: this.bookingDetail.job_detail.job_id,
        action: "edit",

      },

    });
    console.log("bookingDetail", this.bookingDetail)
    this.dismiss();
  }
}
